'use strict';

/**
 * OverlayUtil
 *
 * Utilities for transforming Overlays to be rendered by angular-leaflet
 */

var _ = require('lodash');

function OverlayUtil (tileUtil) {

  /**
   * Extract the layers from the list of overlays
   *
   * @param  {Array.<Object>} overlays List of overlays
   * @return {Object.<Object>} Object representing a collection of tile layers
   */
  this.getLayers = function (overlays, options) {
    return _.reduce(overlays, function (tilelayers, overlay) {
      //overlays are inted on null values
      if(!overlay) {
        return;
      }

      // Overlay currently has only one layer.
      var _tileLayers = tileUtil.getTileLayers(overlay.layers, 'overlay', null, null, options);
      return _.extend(tilelayers, _tileLayers);
    }, {});
  };
}

OverlayUtil.$inject = ['tileUtil'];
module.exports = OverlayUtil;


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/map/src/app/utils/OverlayUtil.js